import { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';

import PreloadPage from './../modules/game/pages/Preload';
import WinPage from './../modules/game/pages/Win';
import LostPage from './../modules/game/pages/Lost';
import Difficulty from '../modules/metro/pages/Difficulty';
import MetroGamePage from '../modules/metro/pages/Game';

const MetroRoutes = () => (
  <Suspense fallback={<div>Загрузка...</div>}>
    <Routes>
      <Route path="/" element={<PreloadPage />} />
      <Route path="/metro/difficulty" element={<Difficulty />} />
      <Route path="/metro/game" element={<MetroGamePage />} />
      <Route path="/win" element={<WinPage />} />
      <Route path="/lost" element={<LostPage />} />
    </Routes>
  </Suspense>
);

export default MetroRoutes;
